var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCreateEvent(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 35,
    height: 35,
    rx: 1.5,
    stroke: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.0435 11.0435C19.0435 10.7667 18.9335 10.5013 18.7379 10.3056C18.5422 10.1099 18.2767 10 18 10C17.7233 10 17.4578 10.1099 17.2621 10.3056C17.0665 10.5013 16.9565 10.7667 16.9565 11.0435V16.9565H11.0435C10.7667 16.9565 10.5013 17.0665 10.3056 17.2621C10.1099 17.4578 10 17.7233 10 18C10 18.2767 10.1099 18.5422 10.3056 18.7379C10.5013 18.9335 10.7667 19.0435 11.0435 19.0435H16.9565V24.9565C16.9565 25.2333 17.0665 25.4987 17.2621 25.6944C17.4578 25.8901 17.7233 26 18 26C18.2767 26 18.5422 25.8901 18.7379 25.6944C18.9335 25.4987 19.0435 25.2333 19.0435 24.9565V19.0435H24.9565C25.2333 19.0435 25.4987 18.9335 25.6944 18.7379C25.8901 18.5422 26 18.2767 26 18C26 17.7233 25.8901 17.4578 25.6944 17.2621C25.4987 17.0665 25.2333 16.9565 24.9565 16.9565H19.0435V11.0435Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateEvent);
export default __webpack_public_path__ + "static/media/create-event.d6d68794ac04e0d0fad5681f739dddd8.svg";
export { ForwardRef as ReactComponent };